import axios from 'axios';
import tokenStore from './tokenStore.js';
import router from './router.js';

const tokenAxios = axios.create({});



tokenAxios.defaults.baseURL = 'http://db.dev.evertop.pl/kateit/api-dev'; // DEV TEST
tokenAxios.defaults.baseURL = 'http://localhost:5896'; // LOCALHOST
tokenAxios.defaults.baseURL = 'http://db.dev.evertop.pl/kateit/api'; // KLIENT TEST
tokenAxios.defaults.baseURL = 'https://api.kateit.pl'; // PROD

tokenAxios.interceptors.request.use(config => {
    var token = tokenStore.getToken();

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

tokenAxios.interceptors.response.use((response) => {
    // Return a successful response back to the calling service
    return response;
}, (error) => {

    if (error.response && error.response.status === 401) {
        tokenStore.clearToken();
        router.push('/public/login');
    }

    else {
        return new Promise((resolve, reject) => {
            reject(error);
        });
    }
});

tokenAxios.downloadFileAsync = async function (fileId) {
    const response = await tokenAxios.get("/files/download", {
        responseType: "arraybuffer",
        params: {
            id: fileId
        }
    });

    return response.data;
};

tokenAxios.getFileUrl = function (fileId) {
    return this.defaults.baseURL + '/files/download?id=' + fileId;
}

export default tokenAxios;